var _rect, _rect2, _rect3, _rect4, _rect5, _rect6, _rect7, _rect8, _rect9, _rect10, _rect11, _rect12, _rect13, _rect14, _path, _path2, _path3, _path4, _rect15;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
import { forwardRef } from "react";
var SvgStoreNoBanner = function SvgStoreNoBanner(_ref, ref) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 82,
    height: 57,
    viewBox: "0 0 82 57",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 1,
    y: 0.5,
    width: 80,
    height: 56,
    rx: 7.5,
    fill: "white"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 6.5,
    y: 6,
    width: 13,
    height: 45,
    rx: 3,
    fill: "currentColor"
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    x: 51.5,
    y: 19,
    width: 11,
    height: 11,
    rx: 3,
    fill: "currentColor"
  })), _rect4 || (_rect4 = /*#__PURE__*/React.createElement("rect", {
    x: 51.5,
    y: 6,
    width: 11,
    height: 11,
    rx: 3,
    fill: "currentColor"
  })), _rect5 || (_rect5 = /*#__PURE__*/React.createElement("rect", {
    x: 51.5,
    y: 32,
    width: 11,
    height: 11,
    rx: 3,
    fill: "currentColor"
  })), _rect6 || (_rect6 = /*#__PURE__*/React.createElement("rect", {
    x: 64.5,
    y: 19,
    width: 11,
    height: 11,
    rx: 3,
    fill: "currentColor"
  })), _rect7 || (_rect7 = /*#__PURE__*/React.createElement("rect", {
    x: 64.5,
    y: 6,
    width: 11,
    height: 11,
    rx: 3,
    fill: "currentColor"
  })), _rect8 || (_rect8 = /*#__PURE__*/React.createElement("rect", {
    x: 64.5,
    y: 32,
    width: 11,
    height: 11,
    rx: 3,
    fill: "currentColor"
  })), _rect9 || (_rect9 = /*#__PURE__*/React.createElement("rect", {
    x: 38.5,
    y: 19,
    width: 11,
    height: 11,
    rx: 3,
    fill: "currentColor"
  })), _rect10 || (_rect10 = /*#__PURE__*/React.createElement("rect", {
    x: 38.5,
    y: 6,
    width: 11,
    height: 11,
    rx: 3,
    fill: "currentColor"
  })), _rect11 || (_rect11 = /*#__PURE__*/React.createElement("rect", {
    x: 38.5,
    y: 32,
    width: 11,
    height: 11,
    rx: 3,
    fill: "currentColor"
  })), _rect12 || (_rect12 = /*#__PURE__*/React.createElement("rect", {
    x: 25.5,
    y: 19,
    width: 11,
    height: 11,
    rx: 3,
    fill: "currentColor"
  })), _rect13 || (_rect13 = /*#__PURE__*/React.createElement("rect", {
    x: 25.5,
    y: 6,
    width: 11,
    height: 11,
    rx: 3,
    fill: "currentColor"
  })), _rect14 || (_rect14 = /*#__PURE__*/React.createElement("rect", {
    x: 25.5,
    y: 32,
    width: 11,
    height: 11,
    rx: 3,
    fill: "currentColor"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M25.5 48C25.5 46.3431 26.8431 45 28.5 45H33.5C35.1569 45 36.5 46.3431 36.5 48V51H25.5V48Z",
    fill: "currentColor"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M38.5 48C38.5 46.3431 39.8431 45 41.5 45H46.5C48.1569 45 49.5 46.3431 49.5 48V51H38.5V48Z",
    fill: "currentColor"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M51.5 48C51.5 46.3431 52.8431 45 54.5 45H59.5C61.1569 45 62.5 46.3431 62.5 48V51H51.5V48Z",
    fill: "currentColor"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M64.5 48C64.5 46.3431 65.8431 45 67.5 45H72.5C74.1569 45 75.5 46.3431 75.5 48V51H64.5V48Z",
    fill: "currentColor"
  })), _rect15 || (_rect15 = /*#__PURE__*/React.createElement("rect", {
    x: 1,
    y: 0.5,
    width: 80,
    height: 56,
    rx: 7.5,
    stroke: "currentColor"
  })));
};
var ForwardRef = /*#__PURE__*/forwardRef(SvgStoreNoBanner);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "store-no-banner.5cd0c017f1c931647573de9b7ace6236.svg";